import { useEffect, useCallback } from 'react';
import { getMessaging, getToken, onMessage } from 'firebase/messaging';
import { doc, setDoc, getDoc } from 'firebase/firestore';
import { db, app } from '../../services/firebase';

const VAPID_KEY = 'BE-NB_oBYdMHsLAFeIaSeV_dyX8FgYAFkmRDYV1UoPrguj8o1YK2DR9dY9mGSBnwB9H_axpGTGoDQIaUYk0yLIE';

export const useFCM = (currentUser: any) => {

  // ── Registrar token FCM del usuario en Firestore ──
  useEffect(() => {
    if (!currentUser?.uid) return;

    const registerToken = async () => {
      try {
        const messaging = getMessaging(app);
        const permission = await Notification.requestPermission();
        if (permission !== 'granted') return;

        const token = await getToken(messaging, {
          vapidKey: VAPID_KEY,
          serviceWorkerRegistration: await navigator.serviceWorker.ready,
        });
        if (!token) return;

        await setDoc(
          doc(db, 'users', currentUser.uid),
          { fcmToken: token, fcmUpdatedAt: new Date() },
          { merge: true }
        );
      } catch (e) {
        console.error('FCM token error:', e);
      }
    };

    registerToken();

    // Escuchar mensajes cuando la app está en foreground
    try {
      const messaging = getMessaging(app);
      const unsub = onMessage(messaging, (payload) => {
        if (document.visibilityState !== 'visible') {
          const { title, body } = payload.notification || {};
          if (title) new Notification(title, { body, requireInteraction: true });
        }
      });
      return unsub;
    } catch (e) {}
  }, [currentUser?.uid]);

  // ── Enviar notificación push al receptor cuando se inicia una llamada ──
  const sendCallNotification = useCallback(async (
    receiverUid: string,
    callData: { callId: string; callerName: string; callType: 'audio' | 'video' }
  ) => {
    try {
      const receiverDoc = await getDoc(doc(db, 'users', receiverUid));
      const fcmToken = receiverDoc.data()?.fcmToken;
      if (!fcmToken) return;

      // Crea el doc que dispara la Cloud Function sendCallPush
      await setDoc(doc(db, 'callNotifications', callData.callId), {
        token: fcmToken,
        receiverUid,
        callerUid: currentUser.uid,
        callerName: callData.callerName,
        callId: callData.callId,
        callType: callData.callType,
        createdAt: new Date(),
      });
    } catch (e) {
      console.error('sendCallNotification error:', e);
    }
  }, [currentUser?.uid]);

  return { sendCallNotification };
};